<template>
  <div>
    <report-section title="血氧趋势" >
    <template v-slot:content>
      <div>
        <div
          :id="title"
          :style="`width: 970px; height: ${200 * zoom}px ;zoom:${
            1 / zoom
          };transform:scale(${zoom});transform-origin:0 0`"
        ></div>
      </div>
    </template>
   
  </report-section>
  
  </div>
 
</template>
          
<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import { DateTool } from "@js/date-tool.js";

export default {
  components: {
    ReportSection,
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      title: "oxgen-section-trend-chart",
      zoom: 1,
      chart: undefined,
    };
  },

  mounted() {
    //解决tooltip偏移问题（结合chart的style）
    const app = document.getElementById("app");
    this.zoom = window.getComputedStyle(app, null).zoom;
    this.chart = this.$echarts.init(document.getElementById(this.title));
    this.drawLine();
  },

  watch: {
    reportDetailModel() {
      this.drawLine();
    },
  },

  methods: {
    // 处理数据，分为两个系列但确保连接
    processDataWithConnection() {
      const originalData = this.reportDetailModel?.bloodOxygenTrandArray || [];
      const highData = []; // >= 90
      const lowData = [];  // < 90
      
      for (let i = 0; i < originalData.length; i++) {
        const currentPoint = originalData[i];
        const prevPoint = originalData[i - 1];
        const nextPoint = originalData[i + 1];
        
        if (currentPoint[1] >= 90) {
          highData.push(currentPoint);
          
          // 如果前一个点小于90，在当前点也加到lowData以连接
          if (prevPoint && prevPoint[1] < 90) {
            lowData.push(currentPoint);
          } else {
            lowData.push([currentPoint[0], null]);
          }
        } else {
          lowData.push(currentPoint);
          
          // 如果前一个点大于等于90，在当前点也加到highData以连接
          if (prevPoint && prevPoint[1] >= 90) {
            highData.push(currentPoint);
          } else {
            highData.push([currentPoint[0], null]);
          }
        }
      }
      
      return { highData, lowData };
    },

    drawLine() {
      const { highData, lowData } = this.processDataWithConnection();
      
      this.chart.setOption({
        axisPointer: {
          link: [
            {
              xAxisIndex: [0],
            },
          ],
        },
        grid: [
          {
            right: 20,
            left: 60,
            top: 40,
            bottom: 60,
          }
        ],
        xAxis: [
          {
            type: "time",
            axisLine: {
              lineStyle: {
                color: "#BABABA",
              },
            },
            splitLine: {
              show: true,
            },
            gridIndex: 0,
          }
        ],
        yAxis: [
          {
            name: "血氧饱和度趋势图(%)",
            type: "value",
            min: 65,
            max: 100,
            axisLine: {
              lineStyle: {
                color: "#BABABA",
              },
            },
            gridIndex: 0,
          }
        ],
        series: [
          {
            name: "血氧饱和度",
            type: "line",
            symbol: "none",
            data: highData,
            lineStyle: {
              width: 1,
              color: "#0872C0" // 蓝色，>= 90
            },
            itemStyle: {
              color: "#0872C0"
            },
            xAxisIndex: 0,
            yAxisIndex: 0,
            connectNulls: false,
          },
          {
            name: "血氧饱和度",
            type: "line",
            symbol: "none",
            data: lowData,
            lineStyle: {
              width: 1,
              color: "#DF7555" // 橙色，< 90
            },
            itemStyle: {
              color: "#DF7555"
            },
            xAxisIndex: 0,
            yAxisIndex: 0,
            connectNulls: false,
          }
        ],
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: (params) => {
            return this.formatterToolTip(params);
          },
        },
      });
    },

    formatterToolTip(params) {
      var tip = "";
      // 过滤掉null值的数据点
      const validParams = params.filter(item => item.value && item.value[1] !== null);
      
      validParams.forEach((item, index) => {
        if (index == 0) {
          const timeStr = DateTool.millisecondTimestampToStr(
            item.data[0],
            "Y_M_D h:m:s"
          );
          tip += timeStr + "<br />";
        }
        const marker = item.marker;
        const seriesName = "血氧饱和度"; // 统一显示名称
        let value = item.value[1];
        let unit = "%";
        
        tip += marker + seriesName + ": " + value + unit + "<br />";
      });
      return tip;
    },
  },
};
</script>
          
<style lang="scss" scoped>
.line-chart {
  @include z-index-2;
  width: 970px !important;
  height: 200px;
  box-sizing: border-box;
}

@media print {
  .custom-divider-mt0 {
    display: none !important;
  }
}
</style>